import React from 'react'
import '../styles/Segmented.css'

const ColonChar = ({}) => {


  return (
    <span style={{paddingLeft: 1, paddingRight: 5}}>:</span>
  )
}

export default ColonChar
